export default {
  bestseller: [],
  endorsement: [],
};
